/**
 * Symbolic profile kinds — numerology ships today; Human Design can attach later
 * without rewriting the numerology pipeline.
 */

export const PROFILE_KINDS = {
  NUMEROLOGY_ONLY: 'numerology_only',
  /** Reserved: second system contributes themes + synthesis */
  NUMEROLOGY_HUMAN_DESIGN: 'numerology_human_design',
  /** Reserved: multi-system unified narrative */
  FULL_SYMBOLIC: 'full_symbolic',
};
